import * as React from 'react';
import LiveRegion from 'live-region';
import { dataLayerPageTitle } from '../Tooling/GoogleTagManagerTooling/Loader';

interface Props {
  title: string;
}

const baseTitle = 'ExecOnline';
const liveRegion = new LiveRegion({
  ariaLive: 'assertive',
  role: 'log',
  ariaRelevant: 'additions',
  ariaAtomic: 'true',
});

class Title extends React.Component<Props, {}> {
  get fullTitle() {
    return `${this.props.title} - ${baseTitle}`;
  }

  componentDidMount() {
    document.title = this.fullTitle;
    liveRegion.announce(this.fullTitle);
    dataLayerPageTitle({ pageTitle: this.fullTitle, event: 'update_page_title' });
  }

  componentDidUpdate() {
    document.title = this.fullTitle;
    liveRegion.announce(this.fullTitle);
    dataLayerPageTitle({ pageTitle: this.fullTitle, event: 'update_page_title' });
  }

  componentWillUnmount() {
    document.title = baseTitle;
  }

  render() {
    return null;
  }
}

export default Title;
